const keys = [
  'C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'
]
const modality = [
  'Minor', 'Major'
]

export {
  keys,
  modality
}



// WEBPACK FOOTER //
// ./src/tools/maps/audio.js